import axios from 'axios';

axios.defaults.baseURL = 'https://mylog.co.il/maccabi/land/101093'
// IF LOCAL
// axios.defaults.baseURL = 'http://localhost/landing_page/101093'

export const formService = {
    saveLead,
    loadCities
}

async function saveLead(lead) {
    return await axios.post(
        '/server/leads/send_lead',
        lead, {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
    ).then(res => {
        return res.data;
    }).catch(err => {
        return err;
    });
}

async function loadCities() {
    return await axios.get('/server/leads/load_cities').then(res => {
        return res.data;
    }).catch(err => {
        return err;
    });
}